/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Agent } from '../../models/agent';
import { ApiResponseAgent } from '../../models/api-response-agent';

export interface CreateAgent$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: Agent
}

export function createAgent(http: HttpClient, rootUrl: string, params: CreateAgent$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseAgent>> {
  const rb = new RequestBuilder(rootUrl, createAgent.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseAgent>;
    })
  );
}

createAgent.PATH = '/v1/api/ui/agent';
